import "./LessonPlansPage.css";

import { useState, useEffect} from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import LessonPlanEditor from "./LessonPlanEditor/LessonPlanEditor";

import axios from "axios";
import { LessonPlanAPIs } from "./api";
import PreviewTable from "./LessonPlanTable/PreviewTable";
import DownloadTable from "./LessonPlanTable/DownloadTable";
import { CircularProgress } from "@material-ui/core";
import { getUserProfile } from "../auth/Auth";
import { readCookie } from "../Functions/Cookies";

function LessonPLanPage() {
  const params = useParams("id");
  const location = useLocation();
  const history = useHistory();
  const [action, setAction] = useState("edit");
  const [loading, setLoading] = useState(false);
  const [lessonplan, setLessonplan] = useState({ rows: [] });

  const user = getUserProfile();

  function updateAction(action) {
    const params = new URLSearchParams({
      action: action,
    });
    history.replace({ pathname: location.pathname, search: params.toString() });
    setAction(action);
  }

  useEffect(() => {
    setAction(new URLSearchParams(location.search).get("action") || "edit");
  }, []);

  useEffect(() => {
    if (loading) return;
    setLoading(true);
    axios
      .get(LessonPlanAPIs.fetchLessonPlan(user.userId, params.id), {
        headers: {
          token:readCookie("token"),
        },
        validateStatus: () => true,
      })
      .then((res) => {
        if (res.data.status !== "success") throw res.data;
        setLessonplan(res.data.data.plan);
      })
      .catch((err) => {
        console.log(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params.id]);

  return (
    <div className={`${action === "download" ? "lp-download-container" : "lp-container"}`}>
      {loading ? (
        <div style={{ width: "fit-content", margin: "50px auto" }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {action === "preview" && (
            <PreviewTable
              staffRole={"school admin"}
              userId={user.userId}
              updateAction={updateAction}
              plan={lessonplan}
            />
          )}
          {action === "download" && (
            <DownloadTable
              teacherName={lessonplan?.teacherId?.name || ""}
              schoolName={user?.schoolName || ""}
              updateAction={updateAction}
              plan={lessonplan}
            />
          )}
        </>
      )}
    </div>
  );
}

export default LessonPLanPage;
